import hh from "hyperscript-helpers";
import {h} from "virtual-dom";
import { showLoginMsg, showUploadMsg, showSearchMsg  } from "../Update";

const { div, main, a, p, h2, article, i, legend, pre } = hh(h);

export function frontPageView(dispatch, model) {
    return main({ className: 'mt4 pv3 black-80 w-80-ns center bg-white-90' }, [
        legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Grundvandsrapporter'),
        p( { className: 'pl1' }, 'Her på siden kan du søge i GEUS\' database over grundvandsrapporter og selv oprette nye grundvandsrapporter.'),
        p( { className: 'pl1' }, 'Der er adgang til knap 8000 grundvandsrapporter, som primært har fokus på grundvandskortlægning og indsatsplanlægning for vandmiljøet. De fleste rapporter er georefererede og omhandler emner som f.eks. grundvandskortlægning, sløjfning af vandboringer, kildepladsundersøgelser, vandindvinding, sårbarhedskortlægning, geofysiske undersøgelser og indsatsplaner.'),
        p( { className: 'pl1' }, [
            'Spørgsmål om oprettelse eller brugen af grundvandsrapporter kan sendes til: ',
            a( { className: 'f6 link dim black pointer', href: 'mailto:jupiter@geus.dk?subject=Vedr.%20jeres%20rapportdatabase' } , 'jupiter@geus.dk.')
        ]),
        article( { className: 'center' }, [
            div({}, [
            div({ className: 'dib-ns tc pa2 mt2', }, [
                p( { className: 'b f5 mr2' }, ' Søg i grundvandsdatabasen'),
                a( { className: 'f6 b link dim br-pill ph3 pv2 dib mb2 white bg-black pointer db', onclick: () => dispatch(showSearchMsg) }, 'SØG I DATABASEN' )
            ]),
            div({ className: 'dib-ns tc pa2 mt2', }, [
                p( { className: 'b f5 mr2' }, ' Slet og ret indberetninger'),
                a( { className: 'f6 b link dim br-pill ph3 pv2 mb2 dib white bg-black pointer db', onclick: () => dispatch(showLoginMsg) }, 'LOG IND' )
            ]),
            div( { className: 'dib-ns tc pa2 mt2' }, [
                p( { className: 'b f5 mr2' }, ' Indsend rapport til grundvandsdatabasen'),
                a( { className: 'f6 b link dim br-pill ph3 pv2 mb2 dib white bg-black pointer db', onclick: () => dispatch(showUploadMsg) }, 'INDSEND RAPPORT' )
            ])
            ])
        ])
    ]);
}
